// Single source of truth for region-aware pricing in the app UI.
// India (IST) sees INR; everyone else sees USD. Matches the Razorpay plan selection
// and the Billing page logic.
const tz = (() => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { return ''; }
})();

export const IS_INDIA = tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta';
export const CURRENCY = IS_INDIA ? 'INR' : 'USD';

// Pro plan
export const PRO_PRICE        = IS_INDIA ? '₹999'        : '$9.99';
export const PRO_PRICE_MO     = IS_INDIA ? '₹999/mo'     : '$9.99/mo';
export const PRO_PRICE_MONTH  = IS_INDIA ? '₹999/month'  : '$9.99/month';

// Additional team seat
export const SEAT_PRICE       = IS_INDIA ? '₹199'        : '$1.99';
export const SEAT_PRICE_MO    = IS_INDIA ? '₹199/mo'     : '$1.99/mo';
